document.addEventListener('DOMContentLoaded', function() {
  const filtersToggleBtn = document.querySelector('.catalog__filterBtn');

  if (!filtersToggleBtn) {
    return;
  }

  const filterPanel = document.querySelector('.catalog__filtersWrp'),
        filterBtnLabel = document.querySelector('.catalog__filterBtnLabel'),
        filterForm = document.querySelector('.catalog__filters'),
        tagsContainer = document.querySelector('.catalog__tags'),
        submitBtn = document.querySelector('.catalog__submitBtn'),
        catalogGrid = document.querySelector('.catalog__grid'),
        checkboxes = document.querySelectorAll('.check__input');

  filtersToggleBtn.addEventListener('click', () => {
    filterPanel.classList.add('catalog__filtersWrp--active')
  });

  document.addEventListener('click', (e) => {
    const panel = e.target.closest('.catalog__filtersWrp');
    const button = e.target.closest('.catalog__filterBtn');

    if (!panel && !button) {
      filterPanel.classList.remove('catalog__filtersWrp--active')
    }

    const resetBtn = document.querySelector('.catalog__emptyBtn');
    if (resetBtn) {
      filterForm.reset();
      const submitEvent = new Event('submit', {
          bubbles: true,
          cancelable: true
      });
      filterForm.dispatchEvent(submitEvent);
    }
  })

  // Function to update filter count
  function updateFilterCount() {
      const checkedCount = document.querySelectorAll('.check__input:checked').length;
      filterBtnLabel.textContent = checkedCount > 0 ? checkedCount : '';
  }

  // Function to create a tag
  function createTag(label, value, name) {
      const tag = document.createElement('button');
      tag.className = 'tags__tag';
      tag.innerHTML = `
          <span>${label}</span>
          <svg><use xlink:href="/img/icons.svg#x"></use></svg>
      `;
      tag.dataset.name = name;
      tag.dataset.value = value;
      tagsContainer.appendChild(tag);
      return tag;
  }

  // Function to remove a tag and uncheck corresponding checkbox
  function removeTag(tag) {
      const name = tag.dataset.name;
      const value = tag.dataset.value;
      const checkbox = document.querySelector(`.check__input[name="${name}"][value="${value}"]`);
      if (checkbox) {
        checkbox.checked = false;
        tag.remove();
        updateFilterCount();
      }
  }

  // Event listener for checkboxes
  checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
          const label = checkbox.parentElement.querySelector('.check__label').textContent;
          const value = checkbox.value;
          const name = checkbox.name;

          if (checkbox.checked) {
              createTag(label, value, name);
          } else {
              const tag = tagsContainer.querySelector(`.tags__tag[data-name="${name}"][data-value="${value}"]`);
              if (tag) tag.remove();
          }
          updateFilterCount();
      });
  });

  // Event listener for tag removal
  tagsContainer.addEventListener('click', (e) => {
      const tag = e.target.closest('.tags__tag');
      if (tag) {
          removeTag(tag);
      }
  });

  // Event listener for reset button
  filterForm.addEventListener('reset', () => {
      checkboxes.forEach(checkbox => {
          checkbox.checked = false;
      });
      tagsContainer.innerHTML = '';
      updateFilterCount();
  });


  filterForm.addEventListener('submit', (e) => {
    e.preventDefault();

    submitBtn.disabled = true;
    submitBtn.textContent = 'Минуту...';

    let data = new FormData(filterForm);

    fetch(filterForm.getAttribute('action'), {
      method: 'POST',
      body: data
    }).then(response => {
      return response.text();
    }).then(data => {
      catalogGrid.innerHTML = data;
    }).catch(function(error) {
      console.error(error);
    }).finally(() => {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Применить';
    });
  })

});